import './style.scss';
document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".lpcb-moving-marker-on-scroll");
    if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const target = entry.target;
                    target.classList.add("is-animated");
                    target.classList.remove("lpcb-moving-marker-on-scroll");
                    observer.unobserve(target);
                }
            });
        }, { threshold: 0.3 });
        elements.forEach((el) => observer.observe(el));
    }
});
